import React from 'react';
import { Card, Button } from 'react-bootstrap';

const ModalButton = ({ handleShow, target, title}) => {
  return (
    <Button
      data-bs-toggle="modal"
      data-bs-target={`#${target}`}
      bsPrefix="card info-card p-0"
      onClick={handleShow}
    >
      <Card.Body className="pb-0">
        <div className="d-flex align-items-center">
          <div className="card-icon rounded-circle d-flex align-items-center justify-content-center w-auto me-3">
            <i className="bi bi-plus-circle"></i>
          </div>
          <Card.Title className="pt-2">{title}</Card.Title>
        </div>
      </Card.Body>
    </Button>
  )
}

export default ModalButton;